class EveningYardage extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-mode]'));
    this.panels = Array.from(this.querySelectorAll('[data-mode-panel]'));
    if (!this.buttons.length || !this.panels.length) return;

    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('[data-mode]');
    if (!button || !this.contains(button)) return;

    const mode = button.dataset.mode;

    this.buttons.forEach((item) => {
      const active = item === button;
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.modePanel !== mode;
    });
  }
}

if (!customElements.get('evening-yardage')) {
  customElements.define('evening-yardage', EveningYardage);
}
